import { render } from "./ManualCreatePage.vue?vue&type=template&id=9b420a54&scoped=true"
import script from "./ManualCreatePage.vue?vue&type=script&lang=js"
export * from "./ManualCreatePage.vue?vue&type=script&lang=js"

import "./ManualCreatePage.vue?vue&type=style&index=0&id=9b420a54&scoped=true&lang=stylus"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b420a54"]])

export default __exports__